import { Quill } from "react-quill-new";
import imageResize from "quill-image-resize-module-react";

// Register image resize module
Quill.register("modules/imageResize", imageResize);

// Register custom Size values
try {
  const Size = Quill.import("attributors/style/size");
  if (Size) {
    Size.whitelist = ["10px", "12px", "14px", "16px", "18px", "20px", "24px", "28px", "32px", "36px", "48px"];
    Quill.register(Size, true);
  }
} catch (_) {}

// Register custom Font values
try {
  const Font = Quill.import("attributors/style/font");
  if (Font) {
    Font.whitelist = ["Arial", "Comic Sans MS", "Courier New", "Georgia", "Helvetica", "Lucida"];
    Quill.register(Font, true);
  }
} catch (_) {}

export function undoChange() {
  this.quill.history.undo();
}

export function redoChange() {
  this.quill.history.redo();
}

export const formats = [
  "size",
  "font",
  "bold",
  "italic",
  "underline",
  "align",
  "strike",
  "script",
  "blockquote",
  "background",
  "list",
  "indent",
  "link",
  "image",
  "color",
  "code-block",
  "width",
  "height",
  "style",
];
